<div *ngIf="message" class="m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible" role="alert">
	<button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
	<span>{{message.text}}</span>
</div>